// src/components/partner-gallery/partner-gallery.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment SponsoredContentBeaconsFragment on SponsoredContentBeacons {\n    renderBeacons\n    viewabilityBeacon\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    text\n    action {\n      ...UILinkActionFragment\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment UILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      urls\n    }\n    resource {\n      ... on HttpURI {\n        value\n      }\n    }\n    target\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSImageLinkFragment on EGDSImageLink {\n    image {\n      url\n      description\n    }\n    action {\n      ...UILinkActionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment ImageGalleryTileCardFragment on EGDSImageLinkCard {\n    title\n    link {\n      ...EGDSImageLinkFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    orientation\n    size\n    url {\n      ... on HttpURI {\n        __typename\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    text\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment ImageGalleryHeaderFragment on SponsoredContentImageGallery {\n    heading\n    paragraph\n    adTransparencyTrigger {\n      adTransparencyId\n      adTransparencyButton {\n        ...AdTransparencyButtonFragment\n      }\n      adTransparencyOverlaySkeleton {\n        ...TransparencyOverlaySkeletonFragment\n      }\n    }\n    link {\n      ...UILinkActionFragment\n    }\n    badge {\n      ...EGDSStandardBadgeFragment\n    }\n    logo {\n      standard {\n        ...EGDSMarkFragment\n      }\n    }\n  }\n\n  fragment AdTransparencyButtonFragment on AdTransparencyButton {\n    primary\n    accessibility\n    disabled\n    size\n    icon {\n      description\n      id\n      title\n    }\n    analyticsPayload\n  }\n  fragment TransparencyOverlaySkeletonFragment on TransparencyOverlaySkeleton {\n    title\n    error {\n      icon {\n        id\n        size\n      }\n      description\n      button {\n        primary\n      }\n      allowedRetryAttempts\n      exceededAttemptsMessage\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  query PartnerGalleryQuery($context: ContextInput!, $sponsoredContentContext: SponsoredContentContextInput!) {\n    sponsoredContent {\n      imageGallery(context: $context, sponsoredContentContext: $sponsoredContentContext) {\n        ...ImageGalleryHeaderFragment\n        beacons {\n          ...SponsoredContentBeaconsFragment\n        }\n        tiles {\n          ...ImageGalleryTileCardFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import React12 from "react";
import { gql as gql8, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/ad-block-detect/ad-block-detect.tsx
import React from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
var AD_BLOCK_DETECTED_EVENT = new SystemEvent(SystemEventLevel.INFO, "AD_BLOCK_DETECTED");
var CollapsedComponent = function() {
    var events = useLoggerEvents({
        AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
    });
    events.AD_BLOCK_DETECTED_EVENT.log({
        message: "collapsing"
    });
    return null;
};
var UncollapsedWrappedComponent = function(props) {
    var children = props.children;
    var events = useLoggerEvents({
        AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
    });
    events.AD_BLOCK_DETECTED_EVENT.log({
        message: "not collapsing"
    });
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
function withAdBlockDetect(WrapperComponent) {
    var WithAdBlockDetectHOC = function(componentProps) {
        var collapseWhenAdBlockDetected = componentProps.collapseWhenAdBlockDetected, adBlockCollapseExperiment = componentProps.adBlockCollapseExperiment;
        var UncollapsedComponent = /* @__PURE__ */ React.createElement(UncollapsedWrappedComponent, null, /* @__PURE__ */ React.createElement(WrapperComponent, _object_spread({}, componentProps)));
        var renderVariant = function() {
            if (adBlockCollapseExperiment === "PG_Acceptable_Ads_Enablement") {
                return /* @__PURE__ */ React.createElement(Experiment, {
                    name: "PG_Acceptable_Ads_Enablement"
                }, /* @__PURE__ */ React.createElement(ExperimentControl, null, /* @__PURE__ */ React.createElement(CollapsedComponent, null)), /* @__PURE__ */ React.createElement(ExperimentVariant, {
                    bucket: 1
                }, UncollapsedComponent));
            }
            if (adBlockCollapseExperiment === "Acceptable_Ads_Component_Enablement") {
                return UncollapsedComponent;
            }
            return /* @__PURE__ */ React.createElement(CollapsedComponent, null);
        };
        if (typeof window !== "undefined") {
            var _window_meso;
            window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
            if (!window.meso.adblock || window.meso.adblock.enabled) {
                if (adBlockCollapseExperiment) {
                    return /* @__PURE__ */ React.createElement(Experiment, {
                        name: "Acceptable_Ads_Component_Enablement"
                    }, /* @__PURE__ */ React.createElement(ExperimentControl, null, /* @__PURE__ */ React.createElement(CollapsedComponent, null)), /* @__PURE__ */ React.createElement(ExperimentVariant, {
                        bucket: 1
                    }, renderVariant()));
                }
                if (collapseWhenAdBlockDetected === false) {
                    return UncollapsedComponent;
                }
                return /* @__PURE__ */ React.createElement(CollapsedComponent, null);
            }
        }
        return /* @__PURE__ */ React.createElement(WrapperComponent, _object_spread({}, componentProps));
    };
    WithAdBlockDetectHOC.displayName = "WithAdBlockDetectHOC";
    return WithAdBlockDetectHOC;
}
// ../internal/src/components/beacons/use-beacons.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
// ../internal/src/components/utils/logger-utils.ts
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2 } from "@shared-ui/logger-context";
var EVENTS = {
    FAIL_TO_SEND_BEACON_USING_BEACON_API: new SystemEvent2(SystemEventLevel2.WARN, "FAIL_TO_SEND_BEACON_USING_BEACON_API" /* FAIL_TO_SEND_BEACON_USING_BEACON_API */ )
};
// ../internal/src/components/beacons/use-beacons.tsx
var SponsoredContentBeaconsFragment = gql(_templateObject());
var fireBeacon = function(beacon, events) {
    try {
        if (!navigator.sendBeacon(encodeURI(beacon))) {
            events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({});
        }
    } catch (error) {
        events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({
            error: error
        });
    }
};
var useBeacons = function(beacons) {
    var loggerEvents = useLoggerEvents2(EVENTS);
    React2.useEffect(function() {
        if (beacons) {
            var _beacons_renderBeacons;
            (_beacons_renderBeacons = beacons.renderBeacons) === null || _beacons_renderBeacons === void 0 ? void 0 : _beacons_renderBeacons.forEach(function(impression) {
                fireBeacon(impression, loggerEvents);
            });
        }
    }, []);
};
// ../internal/src/components/hocs/lazy/lazy.tsx
import React3 from "react";
import LazyLoad from "react-lazy-load";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
function withSponsoredContentLazy(WrappedComponent) {
    var ComponentWithLazy = function(componentProps) {
        var _React3_useState = _sliced_to_array(React3.useState(0), 2), lazyOffset = _React3_useState[0], setLazyOffset = _React3_useState[1];
        React3.useEffect(function() {
            setLazyOffset(window.innerHeight);
        }, []);
        return /* @__PURE__ */ React3.createElement(React3.Fragment, null, !lazyOffset ? null : /* @__PURE__ */ React3.createElement(Viewport, null, /* @__PURE__ */ React3.createElement(ViewSmall, null, /* @__PURE__ */ React3.createElement(LazyLoad, {
            offset: lazyOffset
        }, /* @__PURE__ */ React3.createElement(WrappedComponent, _object_spread({}, componentProps)))), /* @__PURE__ */ React3.createElement(ViewMedium, null, /* @__PURE__ */ React3.createElement(LazyLoad, {
            offset: lazyOffset / 2
        }, /* @__PURE__ */ React3.createElement(WrappedComponent, _object_spread({}, componentProps))))));
    };
    ComponentWithLazy.displayName = "".concat(WrappedComponent.displayName, "WithSponsoredContentLazy");
    return ComponentWithLazy;
}
// ../internal/src/components/image-gallery/image-gallery-tile-card/image-gallery-tile-card.tsx
import React6 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSCard, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { EGDSText } from "@egds/react-core/text";
// ../internal/src/components/egds-image-link/egds-image-link.tsx
import React5 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSFigure, EGDSImage, EGDSImageLink } from "@egds/react-core/images";
// ../internal/src/components/ui-action-link/ui-action-link.tsx
import React4 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var EGDSInlineLinkFragment = gql2(_templateObject1());
var fragment = gql2(_templateObject2());
var _obj;
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
var UILinkAction = function(param) {
    var className = param.className, data = param.data, children = param.children;
    var accessibility = data.accessibility, resource = data.resource, target = data.target, analytics = data.analytics;
    var clickTracker = useClickTracker();
    var onClick = React4.useCallback(function() {
        var _analytics_urls;
        analytics === null || analytics === void 0 ? void 0 : (_analytics_urls = analytics.urls) === null || _analytics_urls === void 0 ? void 0 : _analytics_urls.forEach(function(url) {
            var _navigator;
            (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.sendBeacon(url);
        });
        if ((analytics === null || analytics === void 0 ? void 0 : analytics.referrerId) && (analytics === null || analytics === void 0 ? void 0 : analytics.linkName)) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        clickTracker
    ]);
    if (resource.__typename !== "HttpURI") {
        return null;
    }
    return /* @__PURE__ */ React4.createElement("a", {
        className: className,
        target: UILinkTargetMap[target],
        href: resource.value,
        rel: "noopener",
        onClickCapture: onClick
    }, accessibility && /* @__PURE__ */ React4.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility), children);
};
UILinkAction.fragment = fragment;
UILinkAction.displayName = "UILinkAction";
// ../internal/src/components/egds-image-link/egds-image-link.tsx
var fragment2 = gql3(_templateObject3(), UILinkAction.fragment);
var SponsoredContentEGDSImageLink = function(param) {
    var _param_data = param.data, image = _param_data.image, action = _param_data.action, ratio = param.ratio, roundcorner = param.roundcorner, children = param.children;
    return /* @__PURE__ */ React5.createElement(EGDSFigure, {
        ratio: ratio,
        roundcorner: roundcorner
    }, /* @__PURE__ */ React5.createElement(EGDSImage, {
        placeholderImage: true,
        alt: image.description,
        src: image.url
    }), children, /* @__PURE__ */ React5.createElement(EGDSImageLink, null, /* @__PURE__ */ React5.createElement(UILinkAction, {
        data: action
    })));
};
SponsoredContentEGDSImageLink.fragment = fragment2;
SponsoredContentEGDSImageLink.displayName = "SponsoredContentEGDSImageLink";
// ../internal/src/components/image-gallery/image-gallery-tile-card/image-gallery-tile-card.tsx
var fragment3 = gql4(_templateObject4(), SponsoredContentEGDSImageLink.fragment);
var ImageGalleryTileCard = function(param) {
    var data = param.data, key = param.key, ratio = param.ratio, _param_colSpan = param.colSpan, colSpan = _param_colSpan === void 0 ? 1 : _param_colSpan;
    var link = data.link;
    return /* @__PURE__ */ React6.createElement(EGDSLayoutGridItem, {
        key: key,
        colSpan: colSpan
    }, /* @__PURE__ */ React6.createElement(EGDSCard, null, /* @__PURE__ */ React6.createElement(SponsoredContentEGDSImageLink, {
        data: data.link,
        ratio: ratio
    }, /* @__PURE__ */ React6.createElement(EGDSScrim, {
        type: EGDSScrimType.BOTTOM,
        role: "link"
    }, /* @__PURE__ */ React6.createElement(EGDSText, {
        size: 300
    }, data.title))), /* @__PURE__ */ React6.createElement(EGDSCardLink, null, /* @__PURE__ */ React6.createElement(UILinkAction, {
        data: link.action
    }))));
};
ImageGalleryTileCard.fragment = fragment3;
ImageGalleryTileCard.displayName = "ImageGalleryTileCard";
// ../internal/src/components/meso-viewability/meso-viewability.ts
import React7, { useCallback } from "react";
var useMesoViewability = function(param) {
    var viewabilityBeacon = param.viewabilityBeacon;
    var componentRef = React7.useRef(null);
    var deRegisterViewability = useCallback(function(currentRef) {
        if (currentRef && window.meso) {
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "deregister",
                element: currentRef
            });
        }
    }, []);
    var registerViewability = useCallback(function(currentRef) {
        if (currentRef) {
            var _window_meso;
            window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "register",
                config: "image",
                // the config settings to use: image, video, or large-image
                element: currentRef,
                // reference to the DOM element
                beacon: viewabilityBeacon
            });
        }
    }, [
        viewabilityBeacon
    ]);
    React7.useEffect(function() {
        var currentRef = componentRef.current;
        registerViewability(currentRef);
        return function() {
            deRegisterViewability(currentRef);
        };
    }, [
        registerViewability,
        deRegisterViewability
    ]);
    return {
        componentRef: componentRef
    };
};
// ../internal/src/components/utils/constants.ts
var DEFAULT_SPONSORED_BATCH_KEY = "sponsored-content";
var DEFAULT_SPONSORED_FETCH_POLICY = "no-cache";
// src/components/partner-gallery/partner-gallery.tsx
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/partner-gallery/__private/image-gallery-header/image-gallery-header.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSParagraph } from "@egds/react-core/text";
import { Transparency } from "@shared-ui/retail-sponsored-content-transparency";
// ../internal/src/components/egds-mark/egds-mark.tsx
import React8 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSMark } from "@egds/react-core/mark";
// ../internal/src/components/egds-mark/utils/index.ts
var markSizeMapper = {
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    "11": 11,
    "12": 12,
    "13": 13,
    "14": 14,
    "15": 15,
    "16": 16,
    "17": 17,
    "18": 18,
    "24": 24,
    "30": 30,
    "37": 37,
    "38": 38,
    "40": 40,
    "48": 48,
    "72": 72
};
var _obj1;
var orientationMap = (_obj1 = {}, _define_property(_obj1, "LANDSCAPE" /* LANDSCAPE */ , "landscape"), _define_property(_obj1, "PORTRAIT" /* PORTRAIT */ , "portrait"), _obj1);
// ../internal/src/components/egds-mark/egds-mark.tsx
var __EGDSMarkFragment = gql5(_templateObject5());
var SponsoredContentEGDSMark = function(param) {
    var className = param.className, size = param.size, data = param.data;
    var description = data.description, id = data.id, orientation = data.orientation, url = data.url;
    var markSize;
    if (size) {
        markSize = markSizeMapper[size];
    } else if (data.size) {
        markSize = markSizeMapper[data.size];
    } else {
        markSize = void 0;
    }
    var markOrientation = orientation && orientationMap[orientation] || "landscape";
    return /* @__PURE__ */ React8.createElement(EGDSMark, {
        className: className,
        description: description,
        id: id,
        name: id,
        orientation: markOrientation,
        size: markSize,
        url: url === null || url === void 0 ? void 0 : url.value
    });
};
SponsoredContentEGDSMark.displayName = "SponsoredContentEGDSMark";
SponsoredContentEGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
import React9 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
var fragment4 = gql6(_templateObject6());
var EGDSStandardBadge = function(param) {
    var data = param.data;
    if (!data.text) {
        return null;
    }
    var _data_accessibility;
    return /* @__PURE__ */ React9.createElement(EGDSBadgeStandard, {
        size: "small",
        text: data.text,
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
EGDSStandardBadge.fragment = fragment4;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// src/components/partner-gallery/__private/image-gallery-header/image-gallery-header.tsx
var fragment5 = gql7(_templateObject7(), UILinkAction.fragment, EGDSStandardBadge.fragment, SponsoredContentEGDSMark.fragment);
var gridColumnsWithLogo = {
    small: [
        "1fr",
        "min-content"
    ],
    medium: [
        "auto",
        "1fr",
        "auto"
    ]
};
var gridColumnsWithoutLogo = {
    small: [
        "1fr",
        "min-content"
    ],
    medium: [
        "1fr",
        "auto"
    ]
};
var gridAreasWithLogo = {
    small: [
        "logo badge",
        "text text"
    ],
    medium: [
        "logo text badge"
    ]
};
var gridAreasWithoutLogo = {
    small: [
        "badge badge",
        "text text"
    ],
    medium: [
        "text badge"
    ]
};
var ImageGalleryHeader = function(param) {
    var data = param.data;
    var heading = data.heading, logo = data.logo, link = data.link, paragraph = data.paragraph, badge = data.badge, adTransparencyTrigger = data.adTransparencyTrigger;
    var clickableComponent = function(children) {
        return link ? /* @__PURE__ */ React10.createElement(EGDSLink, null, /* @__PURE__ */ React10.createElement(UILinkAction, {
            data: link
        }, children)) : children;
    };
    return /* @__PURE__ */ React10.createElement(EGDSSpacing, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutGrid, {
        space: "three",
        areas: (logo === null || logo === void 0 ? void 0 : logo.standard) ? gridAreasWithLogo : gridAreasWithoutLogo,
        columns: (logo === null || logo === void 0 ? void 0 : logo.standard) ? gridColumnsWithLogo : gridColumnsWithoutLogo
    }, (logo === null || logo === void 0 ? void 0 : logo.standard) && /* @__PURE__ */ React10.createElement(EGDSLayoutGridItem2, {
        area: "logo"
    }, /* @__PURE__ */ React10.createElement("div", null, clickableComponent(/* @__PURE__ */ React10.createElement(SponsoredContentEGDSMark, {
        data: logo.standard
    })))), /* @__PURE__ */ React10.createElement(EGDSLayoutGridItem2, {
        area: "text"
    }, /* @__PURE__ */ React10.createElement("div", null, clickableComponent(/* @__PURE__ */ React10.createElement(EGDSHeading, {
        tag: "h2",
        size: 5
    }, heading)), clickableComponent(/* @__PURE__ */ React10.createElement(EGDSParagraph, null, paragraph)))), /* @__PURE__ */ React10.createElement(EGDSLayoutGridItem2, {
        area: "badge"
    }, /* @__PURE__ */ React10.createElement("div", null, adTransparencyTrigger ? /* @__PURE__ */ React10.createElement(Transparency, {
        data: adTransparencyTrigger
    }) : badge && /* @__PURE__ */ React10.createElement(EGDSStandardBadge, {
        data: badge
    })))));
};
ImageGalleryHeader.fragment = fragment5;
ImageGalleryHeader.displayName = "ImageGalleryHeader";
// src/components/partner-gallery/__private/partner-gallery-content.tsx
import React11 from "react";
import { EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid2 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
var desktopLayoutGridProps = {
    columns: 3,
    space: "six"
};
var mobileLayoutGridProps = {
    rows: 3,
    space: "three"
};
var PartnerGalleryContent = function(param) {
    var data = param.data, isMobile = param.isMobile, spacingProps = param.spacingProps;
    var tiles = data.tiles, beacons = data.beacons;
    useBeacons(beacons);
    var layoutGridProps = isMobile ? mobileLayoutGridProps : desktopLayoutGridProps;
    return /* @__PURE__ */ React11.createElement(EGDSSpacing2, _object_spread({}, spacingProps), /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(ImageGalleryHeader, {
        data: data
    }), /* @__PURE__ */ React11.createElement(EGDSLayoutGrid2, _object_spread({}, layoutGridProps), tiles.map(function(tile, i) {
        return tile && /* @__PURE__ */ React11.createElement(ImageGalleryTileCard, {
            data: tile,
            key: "tile_".concat(i),
            ratio: EGDSFigureAspectRatioType.R21_9
        });
    }))));
};
PartnerGalleryContent.displayName = "PartnerGalleryContent";
// src/components/partner-gallery/partner-gallery.tsx
var __Query = gql8(_templateObject8(), ImageGalleryHeader.fragment, ImageGalleryTileCard.fragment, SponsoredContentBeaconsFragment);
var PartnerGalleryQueryComponent = function(props) {
    var _data_sponsoredContent_imageGallery_beacons, _data_sponsoredContent_imageGallery, _data_sponsoredContent;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_batchKey = props.batchKey, batchKey = _props_batchKey === void 0 ? DEFAULT_SPONSORED_BATCH_KEY : _props_batchKey, spacingProps = props.spacingProps;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        fetchPolicy: DEFAULT_SPONSORED_FETCH_POLICY
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var viewabilityBeacon = data === null || data === void 0 ? void 0 : (_data_sponsoredContent = data.sponsoredContent) === null || _data_sponsoredContent === void 0 ? void 0 : (_data_sponsoredContent_imageGallery = _data_sponsoredContent.imageGallery) === null || _data_sponsoredContent_imageGallery === void 0 ? void 0 : (_data_sponsoredContent_imageGallery_beacons = _data_sponsoredContent_imageGallery.beacons) === null || _data_sponsoredContent_imageGallery_beacons === void 0 ? void 0 : _data_sponsoredContent_imageGallery_beacons.viewabilityBeacon;
    var componentRef = useMesoViewability({
        viewabilityBeacon: viewabilityBeacon
    }).componentRef;
    if (loading || error || !data || !data.sponsoredContent.imageGallery) {
        return null;
    }
    var tiles = data.sponsoredContent.imageGallery.tiles;
    if (!tiles || tiles.length !== 3) {
        return null;
    }
    return /* @__PURE__ */ React12.createElement("div", {
        "data-eg-sc": true,
        ref: componentRef
    }, /* @__PURE__ */ React12.createElement(Viewport2, null, /* @__PURE__ */ React12.createElement(ViewMedium2, null, /* @__PURE__ */ React12.createElement(PartnerGalleryContent, {
        data: data.sponsoredContent.imageGallery,
        spacingProps: spacingProps
    })), /* @__PURE__ */ React12.createElement(ViewSmall2, null, /* @__PURE__ */ React12.createElement(PartnerGalleryContent, {
        data: data.sponsoredContent.imageGallery,
        spacingProps: spacingProps,
        isMobile: true
    }))));
};
PartnerGalleryQueryComponent.displayName = "sharedui-PartnerGallery";
var PartnerGallery = withAdBlockDetect(withSponsoredContentLazy(PartnerGalleryQueryComponent));
export { PartnerGallery }; /* istanbul ignore file -- @preserve */ 
//# sourceMappingURL=index.js.map